<stb-form [rebrand]="true" [label]="label$ | async" size="flex" [hint]="tip">
  <select
    [ngModel]="selectedAge$ | async"
    (change)="onPayoutAgeChange($event)"
    id="startPayoutAge"
    [disabled]="!(isCurrentYearLoaded$ | async)"
  >
    @for (val of startPayoutAgeRange$ | async; track val) {
      <option [value]="val">
        {{ val | year }}
      </option>
    }
  </select>
</stb-form>
